import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import "./index.css";
import VendorOrderModal from "./VendorOrderModal"; // Import the VendorOrderModal component
import LenderAlertModel from "./LenderAlertModel"; // Import the LenderAlertModel component

const imgCDNURL = process.env.REACT_APP_HW_CDN;
const IMAGE_DIMENSIONS = {
  icon: { width: 25, height: 25 },
  iconLarge: { width: 40, height: 40 },
  smiles: { width: 70, height: 23 },
};

const Portal = (props) => {
  // Add state for managing the vendor modal
  const [vendorModalShow, setVendorModalShow] = useState(false);
  
  // Add state for managing the lender alert modal
  const [lenderAlertShow, setLenderAlertShow] = useState(false);
  
  // Handlers for the vendor modal
  const handleShowVendorModal = () => {
    setVendorModalShow(true);
  };
  
  const handleCloseVendorModal = () => {
    setVendorModalShow(false);
  };
  
  // Handlers for the lender alert modal
  const handleShowLenderAlert = () => {
    setLenderAlertShow(true);
  };
  
  const handleCloseLenderAlert = () => {
    setLenderAlertShow(false);
  };

  const clickEvent = () => {
    window.open(
      "https://www.swmc.com/angelai",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <Container fluid className="servicingPortalContainer">
        <h2>Loan Origination Services</h2>

        <div className="flexRowportal">
          {/* All cards in the flexRowportal remain unchanged */}
          <div className="portal-card-wrapper">
            <Card className="portalCard">
              <button
                type="button"
                className="purechat-button purechat-button-expand"
                style={{ background: "transparent", border: "none" }}
                onClick={clickEvent}
              >
                <div className="portalIconDiv">
                  <img
                    loading="lazy"
                    {...IMAGE_DIMENSIONS.icon}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Morgan-logo.webp"  
                    alt="AngelAi Logo"
                  />
                </div>
                <h3>Talk to AngelAi</h3>
                <p className="textMorgan">
                  Your 24/7 Ai personal assistant that can do almost anything
                  for you.
                </p>
                <div className="rightArrowDiv">
                  <img
                    {...IMAGE_DIMENSIONS.icon}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="arrow-right"
                    loading="eager"
                  />
                </div>
              </button>
            </Card>
          </div>

          {/* Other card-wrappers remain unchanged */}
          <div className="portal-card-wrapper">
            <a
              href="https://seemyloanstatus.com/ReverseMortgage/jsp/extSeeMyLoanStatusLogin.jsf?loginByUsingView=BRK"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "#fff" }}
            >
              <Card className="portalCard">
                <div className="portalIconDivSmiles">
                  <img
                    src="https://resources.swmc.com/swmc-images/HomeImages/SMiLeSCombined.svg"
                    alt="SMiLeS Logo"
                    {...IMAGE_DIMENSIONS.smiles}
                    loading="eager"
                  />
                </div>
                <h3>
                  SeeMyLoanStatus <sup style={{ fontSize: "70%" }}>TM</sup>
                </h3>
                <p>
                  Click here to SeeMyLoanStatus<sup>TM</sup>
                </p>
                <div className="rightArrowDiv">
                  <img
                    {...IMAGE_DIMENSIONS.icon}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="arrow-right"
                    loading="eager"
                  />
                </div>
              </Card>
            </a>
          </div>

          <div className="portal-card-wrapper">
            <Link
              to="/sunsoft-login"
              style={{ textDecoration: "none", color: "#fff" }}
            >
              <Card className="portalCard">
                <div className="portalIconDiv">
                  <img
                    {...IMAGE_DIMENSIONS.iconLarge}
                    src="https://resources.swmc.com/swmc-images/HomeImages/noun_web_user_profile_2904228.svg"
                    alt="noun_web_user_profile"
                    loading="eager"
                  />
                </div>
                <h3>ReverseSoft Login</h3>
                <p>Click here to login to ReverseSoft</p>
                <div className="rightArrowDiv">
                  <img
                    {...IMAGE_DIMENSIONS.icon}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="arrow-right"
                    loading="eager"
                  />
                </div>
              </Card>
            </Link>
          </div>

          <div className="portal-card-wrapper">
            {/* Vendor Portal Card */}
            <Card className="portalCard" onClick={handleShowVendorModal} style={{ cursor: "pointer" }}>
              <div className="portalIconDiv">
                <img
                  {...IMAGE_DIMENSIONS.icon}
                  src="https://resources.swmc.com/swmc-images/HomeImages/Group_37537.svg"
                  alt="Vendor Portal"
                  loading="eager"
                />
              </div>
              <h3>Vendor Portal</h3>
              <p>
                Appraiser, Closing Agents, Inspectors, Realtors - Click Here
              </p>
              <div className="rightArrowDiv">
                <img
                  {...IMAGE_DIMENSIONS.icon}
                  src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                  alt="arrow-right"
                  loading="eager"
                />
              </div>
            </Card>
          </div>

          <div className="portal-card-wrapper">
            {/* Lender Alerts Card - Now using handleShowLenderAlert */}
            <Card className="portalCard" onClick={handleShowLenderAlert} style={{ cursor: "pointer" }}>
              <div className="portalIconDiv">
                <img
                  {...IMAGE_DIMENSIONS.iconLarge}
                  src="https://resources.swmc.com/swmc-images/HomeImages/Group_37538.svg"
                  alt="Lender Alerts"
                  loading="eager"
                />
              </div>
              <h3>Sign Up For Our Lender Alerts</h3>
              <p>Click here to Sign Up</p>
              <div className="rightArrowDiv">
                <img
                  {...IMAGE_DIMENSIONS.icon}
                  src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                  alt="arrow-right"
                  loading="eager"
                />
              </div>
            </Card>
          </div>

          <div className="portal-card-wrapper">
            <a
              href={process.env.REACT_APP_LISTING_SEARCH}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "#fff" }}
            >
              <Card className="portalCard">
                <div className="portalIconDiv1">
                  <img
                    {...IMAGE_DIMENSIONS.icon}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Group%201000006318.svg"
                    alt="Dream House"
                    loading="eager"
                  />
                </div>
                <h3>Shop for your dream house</h3>
                <p>Click here to search your dream home</p>
                <div className="rightArrowDiv">
                  <img
                    {...IMAGE_DIMENSIONS.icon}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="arrow-right"
                    loading="eager"
                  />
                </div>
              </Card>
            </a>
          </div>
        </div>

        <div className="mobileDivforpoertal">
          {/* All cards in the mobileDiv remain unchanged */}
          <div className="portal-card-wrapper">
            <Card className="portalCard">
              <button
                type="button"
                className="purechat-button purechat-button-expand"
                style={{ background: "transparent", border: "none" }}
                onClick={clickEvent}
              >
                <div style={{ display: "flex" }}>
                  <h3 style={{ flex: "85%" }}>Talk to AngelAi</h3>
                  <div className="portalIconDiv" style={{ flex: "10%" }}>
                    <img
                      loading="lazy"
                      width={25}
                      height={25}
                      src="https://resources.swmc.com/swmc-images/HomeImages/Morgan-logo.webp" 
                      alt="AngelAi Logo"
                    />
                  </div>
                </div>
                <p>
                  Your 24/7 Ai personal assistant that can do almost anything
                  for you.
                </p>
                <div className="rightArrowDiv">
                  <img
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="arrow-right"
                    width={25}
                    height={25}
                    loading="eager"
                  />
                </div>
              </button>
            </Card>
          </div>

          {/* Other portal-card-wrapper divs remain unchanged */}
          <div className="portal-card-wrapper">
            <a
              style={{ textDecoration: "none", color: "#fff" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://seemyloanstatus.com/ReverseMortgage/jsp/extSeeMyLoanStatusLogin.jsf?loginByUsingView=BRK"
            >
              <Card className="portalCard">
                <div style={{ display: "flex" }}>
                  <h3 style={{ flex: "85%", paddingTop: "18px" }}>
                    SeeMyLoanStatus <sup style={{ fontSize: "70%" }}>TM</sup>
                  </h3>
                  <div className="portalIconDivSmiles" style={{ flex: "10%" }}>
                    <img
                      src="https://resources.swmc.com/swmc-images/HomeImages/SMiLeSCombined.svg"
                      alt="SMLS Icon"
                      style={{ width: "70px", height: "23px" }}
                      loading="eager"
                    />
                  </div>
                </div>
                <p>
                  Click here to SeeMyLoanStatus<sup>TM</sup>
                </p>
                <div className="rightArrowDiv">
                  <img
                    width={25}
                    height={25}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="arrow-right"
                    loading="eager"
                  />
                </div>
              </Card>
            </a>
          </div>

          <div className="portal-card-wrapper">
            <Link
              style={{ textDecoration: "none", color: "#fff" }}
              to="/sunsoft-login"
            >
              <Card className="portalCard">
                <div style={{ display: "flex" }}>
                  <h3 style={{ flex: "85%" }}>ReverseSoft Login</h3>
                  <div className="portalIconDiv" style={{ flex: "10%" }}>
                    <img
                      style={{ width: "40px" }}
                      src="https://resources.swmc.com/swmc-images/HomeImages/noun_web_user_profile_2904228.svg"
                      alt="noun_web_user_profile"
                      loading="eager"
                    />
                  </div>
                </div>
                <p>Click here to login to ReverseSoft</p>
                <div className="rightArrowDiv">
                  <img
                    width={25}
                    height={25}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="arrow-right"
                    loading="eager"
                  />
                </div>
              </Card>
            </Link>
          </div>

          <div className="portal-card-wrapper">
            {/* Mobile Vendor Portal Card */}
            <Card className="portalCard" onClick={handleShowVendorModal} style={{ cursor: "pointer" }}>
              <div style={{ display: "flex" }}>
                <h3 style={{ flex: "85%" }}>Vendor Portal</h3>
                <div className="portalIconDiv" style={{ flex: "10%" }}>
                  <img
                    src="https://resources.swmc.com/swmc-images/HomeImages/Group_37537.svg"
                    alt="Vendor Portal Icon"
                    width={25}
                    height={25}
                    loading="eager"
                  />
                </div>
              </div>
              <p>
                Appraiser, Closing Agents, Inspectors, Realtors - Click Here
              </p>
              <div className="rightArrowDiv">
                <img
                  width={25}
                  height={25}
                  src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                  alt="arrow-right"
                  loading="eager"
                />
              </div>
            </Card>
          </div>

          <div className="portal-card-wrapper">
            {/* Mobile Lender Alerts Card - Now using handleShowLenderAlert */}
            <Card className="portalCard" onClick={handleShowLenderAlert} style={{ cursor: "pointer" }}>
              <div style={{ display: "flex" }}>
                <h3 style={{ flex: "85%" }}>Sign Up For Our Lender Alerts</h3>
                <div className="portalIconDiv" style={{ flex: "10%" }}>
                  <img
                    src="https://resources.swmc.com/swmc-images/HomeImages/Group_37538.svg"
                    alt="Sign Up Icon"
                    width={40}
                    height={40}
                    loading="eager"
                  />
                </div>
              </div>
              <p>Click here to Sign Up</p>
              <div className="rightArrowDiv">
                <img
                  width={25}
                  height={25}
                  src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                  alt="arrow-right"
                  loading="eager"
                />
              </div>
            </Card>
          </div>

          <div className="portal-card-wrapper">
            <a
              style={{ textDecoration: "none", color: "#fff" }}
              target="_blank"
              rel="noopener noreferrer"
              href={process.env.REACT_APP_LISTING_SEARCH}
            >
              <Card className="portalCard">
                <div style={{ display: "flex" }}>
                  <h3 style={{ flex: "85%" }}>Shop for your dream house</h3>
                  <div className="portalIconDiv1" style={{ flex: "10%" }}>
                    <img
                      src="https://resources.swmc.com/swmc-images/HomeImages/Group%201000006318.svg"
                      alt="Shop Icon"
                      width={25}
                      height={25}
                      loading="eager"
                    />
                  </div>
                </div>
                <p>Click here to search your dream home</p>
                <div className="rightArrowDiv">
                  <img
                    width={25}
                    height={25}
                    src="https://resources.swmc.com/swmc-images/HomeImages/Iconfeather_arrow_right.svg"
                    alt="arrow-right"
                    loading="eager"
                  />
                </div>
              </Card>
            </a>
          </div>
        </div>
      </Container>

      {/* VendorOrderModal component */}
      <VendorOrderModal 
        vendorModalShow={vendorModalShow} 
        handleCloseVendorModal={handleCloseVendorModal} 
      />

      {/* LenderAlertModel component */}
      <LenderAlertModel 
        showModal={lenderAlertShow} 
        handleCloseModal={handleCloseLenderAlert} 
      />
    </>
  );
};

export default React.memo(Portal);